module.exports = __webpack_public_path__ + "static/img/6.629b922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/6.png
// module id = ZJZ9
// module chunks = 0